import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {PlatformComponent} from './platform/platform.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {RedirectComponent} from './redirect/redirect.component';
import {RfqComponent} from './rfq/rfq.component';
import {ResidentialSolarComponent} from './residential-solar/residential-solar.component';
import {LearnAboutSolarComponent} from './residential-solar/learn-about-solar/learn-about-solar.component';
import {
    SizesOfSolarPvSystemsComponent
} from './residential-solar/sizes-of-solar-pv-systems/sizes-of-solar-pv-systems.component';
import {
    BenefitsOfSolarEnergyComponent
} from './residential-solar/benefits-of-solar-energy/benefits-of-solar-energy.component';
import {AboutSolarBatteriesComponent} from './residential-solar/about-solar-batteries/about-solar-batteries.component';
import {
    HowToChooseASolarInstallerComponent
} from './residential-solar/how-to-choose-a-solar-installer/how-to-choose-a-solar-installer.component';
import {
    SiteAssessmentExpectationsComponent
} from './residential-solar/site-assessment-expectations/site-assessment-expectations.component';
import {
    InstallationTimelinesComponent
} from './residential-solar/installation-timelines/installation-timelines.component';
import {
    MaintainingYourSolarPanelsComponent
} from './residential-solar/maintaining-your-solar-panels/maintaining-your-solar-panels.component';
import {
    MonitoringYourSystemComponent
} from './residential-solar/monitoring-your-system/monitoring-your-system.component';
import {
    MaximisingSavingsWithSolarComponent
} from './residential-solar/maximising-savings-with-solar/maximising-savings-with-solar.component';
import {
    YourUtilityBillAfterSolarComponent
} from './residential-solar/your-utility-bill-after-solar/your-utility-bill-after-solar.component';
import {
    UpgradingYourSolarSystemComponent
} from './residential-solar/upgrading-your-solar-system/upgrading-your-solar-system.component';
import {InvertersComponent} from './retail/inverters/inverters.component';
import {ProductComponent} from './retail/product/product.component';
import {BatteriesComponent} from './retail/batteries/batteries.component';
import {PVPanelsComponent} from './retail/pv-panels/pv-panels.component';
import {MountingStructuresComponent} from './retail/mounting-structures/mounting-structures.component';
import {SunsynkComponent} from './retail/brands/sunsynk/sunsynk.component';
import {VictronComponent} from './retail/brands/victron/victron.component';
import {GrowattComponent} from './retail/brands/growatt/growatt.component';
import {CanadianSolarComponent} from './retail/brands/canadian-solar/canadian-solar.component';
import {JaSolarComponent} from './retail/brands/ja-solar/ja-solar.component';
import {GrowcolComponent} from './retail/brands/growcol/growcol.component';
import {TheNextElectricityCrisisComponent} from './news/trending/2024-06-20/the-next-electricity-crisis.component';
import {NewsComponent} from './news/news.component';
import {
    PrivateSolarIsHelpingToKeepTheLightsOn
} from './news/trending/2024-04-15/private-solar-is-helping-to-keep-the-lights-on';
import {
    HowToMaximiseSolarPanelPerformanceInWinter
} from './news/trending/2024-06-01/how-to-maximise-solar-panel-performance-in-winter';
import {
    BigSlowdownInSolarInstallationsInSouthAfrica
} from './news/trending/2024-07-03/big-slowdown-in-solar-installations-in-south-africa';
import {
    WhatYouShouldKnowBeforeInstallingSolarPanelsAndBatteriesComponent
} from './news/trending/2022-07-08/what-you-should-know-before-installing-solar-panels-and-batteries.component';
import {
    GoodNewsForSolarInSouthAfricaComponent
} from './news/trending/2022-07-25/good-news-for-solar-in-south-africa.component';
import {SolarEnergyComponent} from './news/trending/2022-09-12/solar-energy.component';
import {QuoteViewComponent} from './retail/quote-view/quote-view.component';
import {ProductResolverService} from './service/product-resolver.service';
import {VoltaComponent} from './retail/brands/volta/volta.component';
import {LongiComponent} from './retail/brands/longi/longi.component';
import {DeyeComponent} from './retail/brands/deye/deye.component';
import {TermsOfSaleComponent} from './retail/terms-of-sale/terms-of-sale.component';
import {LoginComponent} from './login/login.component';
import {BeyondEskomsLatestIncrease} from './news/trending/2025-08-01/beyond-eskoms-latest-increase';

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'home', component: HomeComponent, redirectTo: '', pathMatch: 'full'},
    {path: 'login', component: LoginComponent},
    {path: 'rfq', component: RfqComponent},
    {path: 'about', component: PlatformComponent},
    {path: 'contact', component: ContactUsComponent},
    {path: 'redirect', component: RedirectComponent},
    {path: 'terms-of-sale', component: TermsOfSaleComponent},
    {path: 'secure', loadChildren: () => import('./secure/secure.module').then(m => m.SecureModule)},
    {path: 'not-found', component: NotFoundComponent},
    {
        path: 'inverters',
        component: InvertersComponent,
        children: [
            {
                path: 'sunsynk-8kw-hybrid',
                component: ProductComponent,
                data: { productCode: 'SS-1P-08K-H-LV' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growatt-5kw-off-grid',
                component: ProductComponent,
                data: { productCode: 'GRO-SPF5000-ES' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-5kw-48v-wifi',
                component: ProductComponent,
                data: { productCode: 'SS-1P-05K-H-LV' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-3-phase-60kw',
                component: ProductComponent,
                data: { productCode: 'GRO-GX60' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-500kw-solar-storage',
                component: ProductComponent,
                data: { productCode: 'GRO-MPS0500' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-50kw-solar-storage',
                component: ProductComponent,
                data: { productCode: 'GRO-MPS0050' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-3-phase-110kw',
                component: ProductComponent,
                data: { productCode: 'GRO-GX110KT' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-100kw-solar-storage',
                component: ProductComponent,
                data: { productCode: 'GRO-MPS0100' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-30kw-solar-storage',
                component: ProductComponent,
                data: { productCode: 'GRO-MPS0030' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-10kw-48v-wifi',
                component: ProductComponent,
                data: { productCode: 'SS-1P-10K-H-LV' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'victron-quattro-48-15000-200',
                component: ProductComponent,
                data: { productCode: 'VIC-QUA483150000' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'victron-quattro-48-10000-140-100',
                component: ProductComponent,
                data: { productCode: 'VIC-QUA481030010' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-8kw-48v-wifi',
                component: ProductComponent,
                data: { productCode: 'SS-1P-08K-H-LV' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-150kw-solar-storage',
                component: ProductComponent,
                data: { productCode: 'GRO-MPS0150' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-8kw-48v-wifi',
                component: ProductComponent,
                data: { productCode: 'GRO-R8KL1' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'deye-8kw-hybrid-inverter',
                component: ProductComponent,
                data: { productCode: 'DEYE-8K-SG05LP1-EU-SM2' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'batteries',
        component: BatteriesComponent,
        children: [
            {
                path: 'volta-5kw-lithium-ion-100ah',
                component: ProductComponent,
                data: { productCode: 'VOL-5KW-SGE-1' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'shoto-5.12kwh-li-ion-48v',
                component: ProductComponent,
                data: { productCode: 'SHO-SDC10' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'pylon-h48074-hv-3.5kwh-48v',
                component: ProductComponent,
                data: { productCode: 'PYL-H48074HV48V' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'pylon-up5000-4.8kwh-48v',
                component: ProductComponent,
                data: { productCode: 'PYL-UP5000' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'pylon-us3000c-3.5kwh-48v',
                component: ProductComponent,
                data: { productCode: 'PYL-US3000C' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-10.65kwh-lithium',
                component: ProductComponent,
                data: { productCode: 'SUN-BATT-10.65' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-5.32kwh-lithium',
                component: ProductComponent,
                data: { productCode: 'SUN-BATT-5.32' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'pv-panels',
        component: PVPanelsComponent,
        children: [
            {
                path: 'canadian-solar-545w-mono',
                component: ProductComponent,
                data: { productCode: 'CS6W-545MS-T' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'ja-solar-545w-mono',
                component: ProductComponent,
                data: { productCode: 'JA-M72S20-545-MR' },
                resolve: { product: ProductResolverService }
            },
            {
                path: 'longi-solar-550w-mono',
                component: ProductComponent,
                data: { productCode: 'LR5-72HPH-550M' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'mounting-structures',
        component: MountingStructuresComponent,
        children: [
            {
                path: 'ali-rail-short-250mm-25-sets-per-box',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-001-250'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'mid-clamp-black-powder-coated',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-007-PC'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'end-stopper-anti-theft',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-006'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'rail-joint-kit-black-powder-coated',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-009-PC'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'end-stopper',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-003'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'end-stopper-anti-theft-black-powder-coated',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-006-PC'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'klip-lock-bracket-black-powder-coated',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-008-PC'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'ali-rail-short-350mm-25-sets-per-box',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-001-350'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'adjust-roof-rail-clamp',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-002-3'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'klip-lock-bracket',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-008'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'tile-roof-brackets',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-M102-0'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'tile-roof-bracket-with-clamp',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-M102-ALL'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'ali-rail-4-8m-bulk-12-rails',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-004-4.8'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'ali-rail-4-4m-bulk-12-rails',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-004'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'rail-joint-kit',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-009'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'mid-clamp',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-007'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'ali-rail-l-bracket',
                component: ProductComponent,
                data: {productCode: 'SC-ELV-005'},
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'sunsynk',
        component: SunsynkComponent,
        children: [
            {
                path: 'sunsynk-5kw-48v-wifi',
                component: ProductComponent,
                data: {productCode: 'SS-1P-05K-H-LV'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-10kw-48v-wifi',
                component: ProductComponent,
                data: {productCode: 'SS-1P-10K-H-LV'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-5.32kwh-lithium',
                component: ProductComponent,
                data: {productCode: 'SUN-BATT-5.32'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-10.65kwh-lithium',
                component: ProductComponent,
                data: {productCode: 'SUN-BATT-10.65'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'sunsynk-8kw-48v-wifi',
                component: ProductComponent,
                data: {productCode: 'SS-1P-08K-H-LV'},
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'victron',
        component: VictronComponent,
        children: [
            {
                path: 'victron-quattro-48-15000-200',
                component: ProductComponent,
                data: {productCode: 'VIC-QUA483150000'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'victron-quattro-48-10000-140-100',
                component: ProductComponent,
                data: {productCode: 'VIC-QUA481030010'},
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'volta',
        component: VoltaComponent,
        children: [
            {
                path: 'volta-5kw-lithium-ion-100ah',
                component: ProductComponent,
                data: { productCode: 'VOL-5KW-SGE-1' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'growatt',
        component: GrowattComponent,
        children: [
            {
                path: 'growatt-5kw-off-grid',
                component: ProductComponent,
                data: {productCode: 'GRO-SPF5000-ES'},
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'canadian-solar',
        component: CanadianSolarComponent,
        children: [
            {
                path: 'canadian-solar-545w-mono',
                component: ProductComponent,
                data: { productCode: 'CS6W-545MS-T' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'growcol',
        component: GrowcolComponent,
        children: [
            {
                path: 'growcol-500kw-solar-storage',
                component: ProductComponent,
                data: {productCode: 'GRO-MPS0500'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-50kw-solar-storage',
                component: ProductComponent,
                data: {productCode: 'GRO-MPS0050'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-3-phase-110kw',
                component: ProductComponent,
                data: {productCode: 'GRO-GX110KT'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-100kw-solar-storage',
                component: ProductComponent,
                data: {productCode: 'GRO-MPS0100'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-30kw-solar-storage',
                component: ProductComponent,
                data: {productCode: 'GRO-MPS0030'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-8kw-48v-wifi',
                component: ProductComponent,
                data: {productCode: 'GRO-R8KL1'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-3-phase-60kw',
                component: ProductComponent,
                data: {productCode: 'GRO-GX60'},
                resolve: { product: ProductResolverService }
            },
            {
                path: 'growcol-150kw-solar-storage',
                component: ProductComponent,
                data: {productCode: 'GRO-MPS0150'},
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'ja-solar',
        component: JaSolarComponent,
        children: [
            {
                path: 'ja-solar-545w-mono',
                component: ProductComponent,
                data: { productCode: 'JA-M72S20-545-MR' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'longi',
        component: LongiComponent,
        children: [
            {
                path: 'longi-solar-550w-mono',
                component: ProductComponent,
                data: { productCode: 'LR5-72HPH-550M' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'deye',
        component: DeyeComponent,
        children: [
            {
                path: 'deye-8kw-hybrid-inverter',
                component: ProductComponent,
                data: { productCode: 'DEYE-8K-SG05LP1-EU-SM2' },
                resolve: { product: ProductResolverService }
            }
        ]
    },
    {
        path: 'residential-solar',
        component: ResidentialSolarComponent,
        children: [
            {
                path: 'learn-about-solar',
                component: LearnAboutSolarComponent
            },
            {
                path: 'sizes-of-solar-pv-systems',
                component: SizesOfSolarPvSystemsComponent
            },
            {
                path: 'benefits-of-solar-energy',
                component: BenefitsOfSolarEnergyComponent
            },
            {
                path: 'about-solar-batteries',
                component: AboutSolarBatteriesComponent
            },
            {
                path: 'how-to-choose-a-solar-installer',
                component: HowToChooseASolarInstallerComponent
            },
            {
                path: 'site-assessment-expectations',
                component: SiteAssessmentExpectationsComponent
            },
            {
                path: 'installation-timelines',
                component: InstallationTimelinesComponent
            },
            {
                path: 'maintaining-your-solar-panels',
                component: MaintainingYourSolarPanelsComponent
            },
            {
                path: 'monitoring-your-system',
                component: MonitoringYourSystemComponent
            },
            {
                path: 'maximising-savings-with-solar',
                component: MaximisingSavingsWithSolarComponent
            },
            {
                path: 'your-utility-bill-after-solar',
                component: YourUtilityBillAfterSolarComponent
            },
            {
                path: 'upgrading-your-solar-system',
                component: UpgradingYourSolarSystemComponent
            }
        ]
    },
    {
        path: 'latest-news',
        component: NewsComponent,
        children: [
            {
                path: 'beyond-eskoms-latest-increase',
                component: BeyondEskomsLatestIncrease
            },
            {
                path: 'the-next-electricity-crisis',
                component: TheNextElectricityCrisisComponent
            },
            {
                path: 'private-solar-is-helping-to-keep-the-lights-on',
                component: PrivateSolarIsHelpingToKeepTheLightsOn
            },
            {
                path: 'how-to-maximise-solar-panel-performance-in-winter',
                component: HowToMaximiseSolarPanelPerformanceInWinter
            },
            {
                path: 'big-slowdown-in-solar-installations-in-south-africa',
                component: BigSlowdownInSolarInstallationsInSouthAfrica
            },
            {
                path: 'what-you-should-know-before-installing-solar-panels-and-batteries',
                component: WhatYouShouldKnowBeforeInstallingSolarPanelsAndBatteriesComponent
            },
            {
                path: 'good-news-for-solar-in-south-africa',
                component: GoodNewsForSolarInSouthAfricaComponent
            },
            {
                path: 'solar-energy',
                component: SolarEnergyComponent
            }
        ]
    },
    {
        path: 'quote-view',
        component: QuoteViewComponent, pathMatch: 'full'
    },
    {path: '**' , redirectTo: '/'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: 'enabledBlocking',
        scrollPositionRestoration: 'enabled',
        enableTracing: true
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
